export function setDocumentTitle(title) {
  const envSuffix = process.env.VUE_APP_ENV === 'live' ? '' : ` - ${process.env.VUE_APP_ENV}`;
  document.title = `${title} - Tracklify${envSuffix}`;
}
